import { select } from '@shared/constants/projectTarget';
import slearnLogo from './assets/slearn_logo.png';
import slearnLogoWhite from './assets/slearn_logo_white.png';
import afterSchoolLogo from './assets/afterschool_logo.png';
import afterSchoolLogoWhite from './assets/afterschool_logo_white.png';
import laschoolLogo from './assets/laschool_logo.png';
import laschoolLogoWhite from './assets/laschool_logo_white.png';

interface BrandImage {
  src: string;
  width: number;
  height: number;
}

export interface PublicServiceBrand {
  service: 'slearn' | 'afterSchool' | 'laschool';
  /** 회원가입 문구·약관에 쓰는 서비스 이름 */
  name: string;
  /** 흰 바탕(폼·사이드바·헤더)용. 시안 로고 프레임 높이 30 */
  logo: BrandImage;
  /** 로그인 캐릭터 패널용 흰 로고. 시안 로고 프레임 높이 36 */
  logoWhite: BrandImage;
}

// 공교육 서비스는 밀당PT 리뉴얼 화면을 그대로 쓰고 로고·이름·로그인 패널 색만 바꾼다(밀당은 undefined).
// 로고는 시안 프레임 크기(위아래 여백 포함)의 3배로 만들었다.
export const publicServiceBrand = select<PublicServiceBrand | undefined>({
  slearn: {
    service: 'slearn',
    name: '서울런',
    logo: { src: slearnLogo, width: 69, height: 30 },
    logoWhite: { src: slearnLogoWhite, width: 83, height: 36 },
  },
  afterSchool: {
    service: 'afterSchool',
    name: '스쿨PT',
    logo: { src: afterSchoolLogo, width: 85, height: 30 },
    logoWhite: { src: afterSchoolLogoWhite, width: 107, height: 36 },
  },
  laschool: {
    service: 'laschool',
    name: '라스쿨PT',
    logo: { src: laschoolLogo, width: 103, height: 30 },
    logoWhite: { src: laschoolLogoWhite, width: 120, height: 36 },
  },
  _default: undefined,
});
